import React from 'react'
import { Container, Table } from 'react-bootstrap'

export const ListSkeleton = () => {
    return (
        <Container
            fluid
            style={{
                fontFamily: "'Poppins', sans-serif",
                backgroundColor: "white",
                height: "calc(100vh - 10rem)",
                padding: 0,
                animation: "cardEntry 1s ease-out forwards",
            }}
            className="mt-3 p-0"
        >
            <div className="mb-0" style={{ height: "100%" }}>
                <Table className="listStyleForContact container-table">
                    <thead style={{ zIndex: 101 }}>
                        <tr style={{ textAlign: "start" }}>
                            <th>#</th>
                            <th>
                                Name{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            {/* {mobile && ( */}
                            <th>
                                Contact No.{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            {/* )} */}
                            <th>
                                Email{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                Owner{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                Report To{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            {/* <th>
                        Visible To{" "}
                        <i
                          class="fa-solid fa-sort"
                          className="inline-block ml-1"
                          size={10}
                        />
                      </th> */}
                            <th>
                                Company Name{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                Designation{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                Department{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                Decision Maker{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                Address{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                City{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                State{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                Country{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                Zipcode{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                Lead Source{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                Tags{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th>
                                Notes{" "}
                                <i
                                    class="fa-solid fa-sort"
                                    className="inline-block ml-1"
                                    size={10}
                                />
                            </th>
                            <th
                                className="lastactionTd"
                            // style={styles.lastdStyle}
                            ></th>
                        </tr>
                    </thead>
                    <tbody style={{ textAlign: "start" }}>
                        {/* Show skeleton rows while loading */}
                        {Array.from({ length: 15 }).map((_, rowIndex) => (
                            <tr
                                key={rowIndex}
                                style={{ marginTop: "10px", marginBottom: "10px" }}
                            >
                                {Array.from({ length: 14 }).map((_, colIndex) => (
                                    <td key={colIndex}>
                                        <div
                                            style={{
                                                height: "20px",
                                                backgroundColor: "#e0e0e0",
                                                borderRadius: "4px",
                                                animation: "pulse 1.5s ease-in-out infinite",
                                                width:
                                                    colIndex === 0
                                                        ? "30px"
                                                        : colIndex === 1
                                                            ? "120px"
                                                            : "80px",
                                            }}
                                        ></div>
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </Container>
    )
}
